var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "modal",
        class: _vm.value ? "show" : "hide",
        style: _vm.value
          ? "display:block;background-color:#3333337a;"
          : "display:none;",
        attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass: "modal-header d-flex flex-row align-items-center"
                },
                [
                  _c("h3", [
                    _vm._v("Demande #" + _vm._s(_vm.row_cr.cr_id) + " "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mustCallBack(
                              _vm.row_cr.cr_reason,
                              _vm.row_cr.cr_status
                            ),
                            expression:
                              "mustCallBack(row_cr.cr_reason, row_cr.cr_status)"
                          }
                        ]
                      },
                      [
                        _vm._v(" - "),
                        _c("icon", {
                          attrs: {
                            name: "phone-alt",
                            scale: "1.5",
                            color: "green"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c("div", { staticClass: "modal-body" }, [
                _vm.editionMode
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col col-lg-7" },
                        [
                          _c("h4", [_vm._v("Mettre à jour le statut")]),
                          _c("m-form-select", {
                            attrs: {
                              label: "Nouveau statut",
                              "label-position": "top",
                              name: _vm.$Utils.randomstring("filterStatus"),
                              items: _vm.$store.state.items_cr_statuses
                            },
                            model: {
                              value: _vm.status,
                              callback: function($$v) {
                                _vm.status = $$v
                              },
                              expression: "status"
                            }
                          }),
                          _c("m-form-text", {
                            attrs: {
                              rows: 8,
                              label: "Commentaire",
                              type: "textarea"
                            },
                            model: {
                              value: _vm.comment,
                              callback: function($$v) {
                                _vm.comment = $$v
                              },
                              expression: "comment"
                            }
                          }),
                          _vm.commentError
                            ? _c("div", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.commentError))
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.status === "KIT_BACK_COMPLETE_DEFECT" ||
                                    _vm.status === "KIT_BACK_INCOMPLETE",
                                  expression:
                                    "status === 'KIT_BACK_COMPLETE_DEFECT' || status === 'KIT_BACK_INCOMPLETE'"
                                }
                              ]
                            },
                            [
                              _c("m-form-file", {
                                attrs: {
                                  label: "Télécharger une photo",
                                  type: "image"
                                },
                                on: { inputfile: _vm.savefile },
                                model: {
                                  value: _vm.file,
                                  callback: function($$v) {
                                    _vm.file = $$v
                                  },
                                  expression: "file"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "col col-lg-5" }, [
                        _c("h4", [_vm._v("Réponses prédéfinies")]),
                        _c(
                          "ul",
                          _vm._l(_vm.predefinedMessagesList, function(
                            message,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: index,
                                on: {
                                  click: function($event) {
                                    return _vm.setPredefinedMessages(
                                      message.key
                                    )
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(message.description) + " ")]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("h4", [_vm._v("Information")]),
                        _c("table", { staticClass: "table table-sm" }, [
                          _c("tbody", [
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right cr_label_cell" },
                                [_vm._v("Contact :")]
                              ),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript: void" },
                                    on: { click: _vm.goToContactDetails }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.row_cr.co_id.co_invoice_firstname
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.row_cr.co_id.co_invoice_name
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("div", [
                                  _c("small", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.$Utils
                                            .formatPhoneNumber(
                                              _vm.row_cr.co_id.co_invoice_tel,
                                              _vm.row_cr.co_id
                                                .co_invoice_country
                                            )
                                            .getURI()
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$Utils
                                                .formatPhoneNumber(
                                                  _vm.row_cr.co_id
                                                    .co_invoice_tel,
                                                  _vm.row_cr.co_id
                                                    .co_invoice_country
                                                )
                                                .formatInternational()
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _c("div", [
                                  _c("small", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "mailto:" +
                                            _vm.row_cr.co_id.co_invoice_email
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.row_cr.co_id.co_invoice_email
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right cr_label_cell" },
                                [_vm._v("Bénéficiaire :")]
                              ),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript: void" },
                                    on: { click: _vm.goToBoxDetails }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.row_cr.en_id.en_fullname) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right cr_label_cell" },
                                [_vm._v("Motif :")]
                              ),
                              _c("td", [
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm
                                          .getCancellationReason(
                                            _vm.row_cr.cr_reason
                                          )
                                          .join(". ")
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right cr_label_cell" },
                                [_vm._v("Comment. :")]
                              ),
                              _c("td", [
                                _vm.row_cr.cr_reason_comment
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.row_cr.cr_reason_comment) +
                                          " "
                                      )
                                    ])
                                  : _c("span", [_vm._v(" - ")])
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right cr_label_cell" },
                                [_vm._v("Documents :")]
                              ),
                              _c("td", [
                                _vm.row_cr.cr_documents
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        _vm.row_cr.cr_documents.list,
                                        function(file, fileIndex) {
                                          return _c("div", { key: fileIndex }, [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  target: "_blank",
                                                  href:
                                                    _vm.$config.server_url +
                                                    "/" +
                                                    file.path,
                                                  download: file.name
                                                }
                                              },
                                              [_vm._v(_vm._s(file.name))]
                                            )
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : _c("div", [_vm._v(" - ")])
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right cr_label_cell" },
                                [_vm._v(" Statut : ")]
                              ),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getCancellationStatus(
                                        _vm.row_cr.cr_status
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right cr_label_cell" },
                                [_vm._v(" Mis à jour le : ")]
                              ),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm
                                        .$moment(_vm.row_cr.cr_status_date)
                                        .format("DD/MM/YYYY HH:mm")
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("h4", [_vm._v("Suivi de la demande")]),
                        _c("table", { staticClass: "table table-sm" }, [
                          _c(
                            "tbody",
                            _vm._l(_vm.row_cr.cr_history.list, function(
                              item,
                              index
                            ) {
                              return _c("tr", { key: index }, [
                                _c("td", { staticClass: "cr_label_cell" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm
                                          .$moment(item.date)
                                          .format("DD/MM/YYYY HH:mm")
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getCancellationStatus(item.status)
                                      ) +
                                      " "
                                  ),
                                  item.comment
                                    ? _c("p", [
                                        _c("i", [
                                          _c("pre", [
                                            _vm._v(_vm._s(item.comment))
                                          ])
                                        ])
                                      ])
                                    : _vm._e()
                                ])
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    ])
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _vm.editionMode
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.cancelEditStatus }
                        },
                        [_vm._v("Annuler")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-2",
                          attrs: { type: "button" },
                          on: { click: _vm.updateStatus }
                        },
                        [_vm._v("Mettre à jour")]
                      )
                    ])
                  : _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.cancelWin }
                        },
                        [_vm._v("Fermer")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-2",
                          attrs: { type: "button" },
                          on: { click: _vm.editStatus }
                        },
                        [_vm._v("Modifier")]
                      )
                    ])
              ])
            ])
          ]
        ),
        _c("m-message-dialog", {
          attrs: { title: "Erreur", text: _vm.dialogErrTxt },
          model: {
            value: _vm.dialogErr,
            callback: function($$v) {
              _vm.dialogErr = $$v
            },
            expression: "dialogErr"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }